module.exports = __webpack_public_path__ + "static/media/stick-figures-3.bbe10870.png";